<template>
  <div class="job-info-container">
    <div>
      <div class="job-info-item">

        <div class="job-profile-image-container">
          <img v-if="userJob.jobCoverPhotoUrl" v-bind:src="userJob.jobCoverPhotoUrl" alt="Job cover photo" />
          <img v-else src="../../assets/images/image-placeholder.png" alt="Image placeholder" />
        </div>

        <div class="job-info">
            <div class="info-wrapper">
                <div class="sub-heading">JOB TITLE</div>
                <div class="actual-info">{{userJob.title}} | {{ userJob.employmentType }}</div>
            </div>

            <div v-if="userJob.companyName" class="info-wrapper">
                <div class="sub-heading">COMPANY</div>
                <div class="actual-info">{{userJob.companyName}}</div>
            </div>

            <div v-if="jobLocation && jobLocation !== 'undefined'" class="info-wrapper">
                <div class="sub-heading">LOCATION</div>
                <div class="actual-info">{{jobLocation}}</div>
            </div>

            <div v-if="userJob.jobDeadline" class="info-wrapper">
                <div class="sub-heading">DEADLINE</div>
                <div class="actual-info">{{ new Date(userJob.jobDeadline).toDateString() }}</div>
            </div>
        </div>

      </div>
    </div>

    <!-- Job Description container starts here -->
    <div class="description-container">
      <div class="heading">JOB DESCRIPTION</div>
      <div class="description">{{userJob.jobDescription}}</div>
    </div>
    <!-- Job Description container ends here -->

    <!-- Job Questions -->
    <div class="questions-container">
      <div v-if="userJob?.applicantQuestionOne" class="questions-wrapper">
        <div class="sub-heading">JOB QUESTION 1</div>
        <div class="actual-info">{{ userJob.applicantQuestionOne }}</div>
      </div>

      <div v-if="userJob?.applicantQuestionTwo" class="questions-wrapper">
        <div class="sub-heading">JOB QUESTION 2</div>
        <div class="actual-info">{{ userJob.applicantQuestionTwo }}</div>
      </div>

      <div v-if="userJob?.applicantQuestionThree" class="questions-wrapper">
        <div class="sub-heading">JOB QUESTION 3</div>
        <div class="actual-info">{{ userJob.applicantQuestionThree }}</div>
      </div>
    </div>
    <!-- Job Questions ends here -->

    <!-- Job Creator Action Buttons -->
    <div
      v-if="loggedInUserId === userJob.creator ||
      loggedInUserId === userJob.agencyCreator"
      class="lower-create-button-container"
    >
      <button  class="delete-job-btn" @click="deleteJobHandler(userJob.id)">
        <div>Delete Job</div>
      </button>
      <button  class="copy-job-btn" @click="generateCopyLink(userJob.id)">
        <div>Share Job Link</div>
      </button>
    </div>

    <!-- Modal component for actions confirmation -->
    <div v-if="showModal">
      <ActionModal
        :verb="'delete'"
        :subject="'job'"
        v-on:modalAction="modalAction"
      />
    </div>
  </div>
</template>

<script>
import ActionModal from '../Modals/ActionModal.vue';

export default {
  name: 'JobInfo',
  props:[
    'userJob',
    'jobLocation'
  ],
  components: {
    ActionModal
  },
  data(){
    return{
      showModal: false,
    };
  },
  computed: {
    loggedInUserId(){
      return this.$store.state.userId;
    }
  },
  methods: {
    async modalAction(value) {
      //toggle modal
      this.showModal = !this.showModal;
        // decide action
        value === 'yes' ?
        await this.$store.dispatch('deleteJob', this.modalSubjectId)
          .then((res) => {
            if(res.response){
              this.$toastr.success(res.response.message, 'Success');
              this.$emit('backToJobs', 'Jobs');
            }else if(res.error) {
              this.$toastr.error(res.error.error, 'Failed');
            }
          })
        : this.closeModal();
    },
    closeModal () {
      this.showModal = false;
    },
    deleteJobHandler(id) {
      this.showModal = !this.showModal;
      this.modalSubjectId = id;
    },
    generateCopyLink(id){
      // Construct the job link URL bearing in mind that .env url value includes the trailing slash
      const url = `${process.env.VUE_APP_BASE_URL}user/jobs/${id}/share`;
      const el = document.createElement('textarea');
      el.value = url;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();

      let success = document.execCommand('copy');
      success
      ? this.$toastr.success('Link copied to clipboard!', 'Success')
      : this.$toastr.error('Unable to copy link to clipboard', 'Error');
    }
  },

  beforeMount () {
  },

  updated () {
  }
};
</script>

<style scoped>
 .job-info-container{
    background:white;
    border-radius:15px;
  }

  .job-info-item {
    display:flex;
    /* align-items:center; */
    align-items:flex-start;
    flex-wrap:wrap;
  }

  .job-profile-image-container {
    width: 300px;
    height: 360px;
    margin: 0 50px 5px 0;
    border-radius: 15px;
  }

  .job-profile-image-container img {
    border-radius: 15px 0 0 0;
    object-fit: cover;
    width: 300px;
    height: 100%;
  }

  .job-info .sub-heading, .questions-container .sub-heading {
    font-weight: 700;
    color: #252525;
    padding-bottom: 5px;
  }

  .job-info .actual-info, .questions-container .actual-info {
    font-weight: 500;
    color: #828282;
  }

  .job-info .sub-heading, .job-info .actual-info {
    text-transform: capitalize;
    line-height: 1.6rem;
  }

  .description-container {
    margin-top: 40px;
  }

  .description-container .heading {
    font-weight: 600;
    color: black;
    font-size: 18px;
    margin: 18px;
  }

  .description-container .description {
    color:#707070;
    font-size:18px;
    line-height:194%;
    margin:18px;
    white-space: pre-wrap;
  }

  .questions-container {
    margin: 60px 15px 30px 15px;
  }

  .questions-wrapper {
    margin-bottom: 40px;
  }

  .info-wrapper {
    margin-bottom:40px;
  }

  .info-wrapper:last-child {
    margin-bottom:0;
  }

  .lower-create-button-container {
    margin:40px;
    display:flex;
    justify-content:flex-end;
  }
  .lower-create-button-container button {
    display:flex;
    width:188px;
    height:54px;
    align-items:center;
    justify-content:center;
  }

  .lower-create-button-container img {
    width:23px;
    margin-right:12px
  }

  .copy-job-btn, .delete-job-btn {
    font-size:1.125rem;
    font-weight:600;
    background:var(--colorPrimary);
    border:none;
    color:var(--white);
    border-radius:5px;
    margin-left:30px;
  }
  .delete-job-btn {
    background: var(--white);
    color: orangered;
    border: 1px solid orangered;
  }

  .job-info{
    margin: 30px 15px;
  }

  @media (min-width:991px) and (max-width:1325px) {
    /* Set Job Cover Image container and Image to be full width*/
    .job-profile-image-container {
      width: 100%;
      margin: 0;
    }
    .job-profile-image-container img {
      width: 100%;
      border-radius: 15px 15px 0 0
    }
  }
  @media only screen and (max-width:1178px) {

  }

  @media only screen and (max-width:1078px) {

  }

  @media only screen and (max-width:990px) {

  }

  @media only screen and (max-width:894px) {
    /* Set Job Cover Image container and Image to be full width*/
    .job-profile-image-container {
      width: 100%;
      margin: 0;
    }
    .job-profile-image-container img {
      width: 100%;
      border-radius: 15px 15px 0 0
    }
  }

  @media only screen and (max-width: 768px) {
    .lower-create-button-container {
      margin:40px auto;
      padding: 0 10px 40px;
    }
  }

  @media only screen and (max-width: 565px) {

  }

  @media only screen and (max-width: 420px) {

  }
</style>
